// @flow
export const PLATFORM = 'hivehome';
export const CONFIG = 'power-consumption';

export const GET_POWER_CONSUMPTION = 'hive/power-consumption/get';
export const RECEIVE_POWER_CONSUMPTION = 'hive/power-consumption/receive';
export const SHOW_ESTIMATED_COST_MODAL = 'hive/power-consumption/SHOW_ESTIMATED_COST_MODAL';
export const HIDE_ESTIMATED_COST_MODAL = 'hive/power-consumption/HIDE_ESTIMATED_COST_MODAL';



// WEBPACK FOOTER //
// ./src/core/state/power-consumption/constants.js